
import Vue from 'vue'
import { GetAllMyArqanaHorseRegistrationDto, myRegistrationApi } from '@/api/auth/myHorseRegistration'
import snackbarStore from '@/store/snackbarStore'
import { getCountryLabel } from '@/utils/countries'
import { getBreedsLabel } from '@/utils/breeds'
import { getRobesLabel } from '@/utils/robes'
import { getHorseTypeLabel } from '@/utils/horseType'
import { getGenderLabel } from '@/utils/genders'
import { formatPhoneNumber } from '@/utils/phone'
import { formatDate } from '@/utils/dates'
import { formatAddress } from '@/utils/addresses'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default Vue.extend({
  name: 'RegistrationConsignment',
  components: {
    ConfirmDialog,
  },
  data: () => ({
    loading: false,
    error: '',
    registrations: [] as GetAllMyArqanaHorseRegistrationDto[],
    totalItems: 0,
    pageSize: 20,
    loadingRegistration: false,
    registrationDialog: false,
    registrationToView: undefined as undefined | GetAllMyArqanaHorseRegistrationDto,
    confirmAcceptDialog: false,
    confirmRejectDialog: false,
    focusedRegistration: undefined as undefined | GetAllMyArqanaHorseRegistrationDto,
    sendingAccept: false,
    sendingReject: false,
  }),
  methods: {
    getCountryLabel,
    getBreedsLabel,
    getRobesLabel,
    getHorseTypeLabel,
    getGenderLabel,
    formatPhoneNumber,
    formatDate,
    formatAddress,
    async loadItems() {
      this.loading = true
      try {
        this.registrations = (await myRegistrationApi.getByConsigner({ page: this.page - 1, size: this.pageSize, sort: ['createdTime,DESC'] })).content
        this.totalItems = await myRegistrationApi.countByConsigner()
      } catch (e) {
        snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
      }
      this.loading = false
    },
    setCurrentPage(page: number) {
      if (page !== this.page) {
        this.$router.push({ query: { page: page.toString() } })
      }
    },
    async showRegistration(r: GetAllMyArqanaHorseRegistrationDto) {
      this.loadingRegistration = true
      await myRegistrationApi.findById(r.id).then(registration => {
        this.registrationToView = registration
        this.registrationDialog = true
      }).catch(() => {
        snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
      })
      this.loadingRegistration = false
    },
    acceptRegistration(r: GetAllMyArqanaHorseRegistrationDto) {
      this.confirmAcceptDialog = true
      this.focusedRegistration = r
      this.$emit('reload')
    },
    rejectRegistration(r: GetAllMyArqanaHorseRegistrationDto) {
      this.confirmRejectDialog = true
      this.focusedRegistration = r
    },
    async confirmAccept() {
      if (this.focusedRegistration) {
        this.sendingAccept = true
        try {
          await myRegistrationApi.consignerAccept(this.focusedRegistration)
          this.loadItems()
          this.$emit('reload')
        } catch (e) {
          snackbarStore.setSnackbar({ text: this.$t('error.sending') as string, color: 'error' })
        }
        this.sendingAccept = false
        this.closeAccept()
      }
    },
    async confirmReject() {
      if (this.focusedRegistration) {
        this.sendingReject = true
        try {
          await myRegistrationApi.consignerReject(this.focusedRegistration)
          this.loadItems()
          this.$emit('reload')
        } catch (e) {
          snackbarStore.setSnackbar({ text: this.$t('error.sending') as string, color: 'error' })
        }
        this.sendingReject = false
        this.closeReject()
      }
    },
    closeAccept() {
      this.confirmAcceptDialog = false
      this.focusedRegistration = undefined
    },
    closeReject() {
      this.confirmRejectDialog = false
      this.focusedRegistration = undefined
    },
  },
  computed: {
    page(): number {
      return parseInt(this.$route.query.page as string ?? '1', 10)
    },
  },
  mounted() {
    this.loadItems()
  },
  watch: {
    page() {
      this.loadItems()
    },
  },
})
